import React, { useState } from 'react';
import './CastingApplicationPage.css';

function LawApplicationPage({ onNavigate }) {
  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    currentCity: '',
    currentState: '',
    lawDegree: '',
    lawSchool: '',
    graduationYear: '',
    barAdmissionStatus: '',
    licensedInNY: '',
    licensedInFL: '',
    otherLicensedStates: '',
    yearsExperience: '',
    practiceArea: '',
    currentEmployer: '',
    jobTitle: '',
    linkedin: '',
    resumeLink: '',
    professionalBio: '',
    availability: '',
    travelFlexibility: ''
  });

  const getOrCreateGenesisID = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.genesisID) {
      return currentUser.genesisID;
    }

    let wandererID = localStorage.getItem('wandererGenesisID');
    if (!wandererID) {
      const randomNum = Math.floor(1000000 + Math.random() * 9000000);
      wandererID = `W${randomNum}`;
      localStorage.setItem('wandererGenesisID', wandererID);
    }

    return wandererID;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const genesisID = getOrCreateGenesisID();

      const response = await fetch('https://1kn7g0vf8j.execute-api.us-east-1.amazonaws.com/submitLawApplication', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          genesisID,
          formData,
          email: formData.email
        })
      });

      const result = await response.json();

      if (result.success) {
        alert(`Application submitted successfully!\n\nYour Genesis ID: ${genesisID}\n\nCertificate will be sent to ${formData.email}`);
        onNavigate('home');
      } else {
        alert('Failed to submit application: ' + (result.error || 'Unknown error'));
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('Failed to submit application. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="casting-page">
      <div className="casting-container">
        <div className="casting-form">
          <div className="casting-header">
            <h2>Law / Legal Professionals</h2>
            <p>Law degree required, licensed in New York (NY) and/or Florida (FL) — both preferred</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-section">
              <h3>
                <span className="section-number">1</span>
                Professional Information
              </h3>

              <div className="form-row">
                <div className="form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone</label>
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                  />
                </div>
                <div className="form-group">
                  <label>Current City</label>
                  <input
                    type="text"
                    name="currentCity"
                    value={formData.currentCity}
                    onChange={handleChange}
                    placeholder="Enter your city"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Current State</label>
                  <input
                    type="text"
                    name="currentState"
                    value={formData.currentState}
                    onChange={handleChange}
                    placeholder="Enter your state"
                  />
                </div>
                <div className="form-group">
                  <label>Law Degree</label>
                  <select
                    name="lawDegree"
                    value={formData.lawDegree}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="JD">JD</option>
                    <option value="LLM">LLM</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Law School</label>
                  <input
                    type="text"
                    name="lawSchool"
                    value={formData.lawSchool}
                    onChange={handleChange}
                    placeholder="Enter law school / university"
                  />
                </div>
                <div className="form-group">
                  <label>Graduation Year</label>
                  <input
                    type="number"
                    name="graduationYear"
                    value={formData.graduationYear}
                    onChange={handleChange}
                    placeholder="Enter graduation year"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Bar Admission Status</label>
                  <select
                    name="barAdmissionStatus"
                    value={formData.barAdmissionStatus}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Active">Active</option>
                    <option value="Pending">Pending</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Years of Experience</label>
                  <select
                    name="yearsExperience"
                    value={formData.yearsExperience}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="0-1">0-1 years</option>
                    <option value="2-5">2-5 years</option>
                    <option value="6-10">6-10 years</option>
                    <option value="10+">10+ years</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Licensed in New York (NY)</label>
                  <select
                    name="licensedInNY"
                    value={formData.licensedInNY}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Licensed in Florida (FL)</label>
                  <select
                    name="licensedInFL"
                    value={formData.licensedInFL}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Other Licensed States (Optional)</label>
                <input
                  type="text"
                  name="otherLicensedStates"
                  value={formData.otherLicensedStates}
                  onChange={handleChange}
                  placeholder="e.g. California, Texas"
                />
              </div>

              <div className="form-group">
                <label>Practice Area (Optional)</label>
                <input
                  type="text"
                  name="practiceArea"
                  value={formData.practiceArea}
                  onChange={handleChange}
                  placeholder="e.g. Corporate, Litigation, Family Law"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Current Employer / Firm</label>
                  <input
                    type="text"
                    name="currentEmployer"
                    value={formData.currentEmployer}
                    onChange={handleChange}
                    placeholder="Enter current employer or firm"
                  />
                </div>
                <div className="form-group">
                  <label>Job Title</label>
                  <input
                    type="text"
                    name="jobTitle"
                    value={formData.jobTitle}
                    onChange={handleChange}
                    placeholder="Enter your job title"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>LinkedIn (Optional)</label>
                  <input
                    type="text"
                    name="linkedin"
                    value={formData.linkedin}
                    onChange={handleChange}
                    placeholder="LinkedIn profile URL"
                  />
                </div>
                <div className="form-group">
                  <label>Resume Link (Optional)</label>
                  <input
                    type="text"
                    name="resumeLink"
                    value={formData.resumeLink}
                    onChange={handleChange}
                    placeholder="Link to resume / CV"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Professional Bio</label>
                <textarea
                  name="professionalBio"
                  value={formData.professionalBio}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Tell us about your legal background"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Availability</label>
                  <input
                    type="text"
                    name="availability"
                    value={formData.availability}
                    onChange={handleChange}
                    placeholder="e.g. Immediate, 2 weeks notice"
                  />
                </div>
                <div className="form-group">
                  <label>Travel Flexibility</label>
                  <select
                    name="travelFlexibility"
                    value={formData.travelFlexibility}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="Limited">Limited</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="navigation-buttons">
              <button
                type="button"
                className="btn-prev"
                onClick={() => onNavigate('casting-menu')}
              >
                Back
              </button>
              <button
                className="btn-submit"
                type="submit"
                disabled={submitting}
              >
                {submitting ? 'Submitting...' : 'Submit Application'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LawApplicationPage;